import React from 'react';
import { IconProps } from '../const';

export const VisibilityIcon = ({ width, height, className }: IconProps) => {
  const _w = width || '24';
  const _h = height || '24';
  const _cn = className || '';

  return (
    <svg width={_w} height={_h} className={_cn} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="3.5" stroke="currentColor" />
      <path
        d="M20.188 10.9343C20.5762 11.4056 20.7703 11.6412 20.7703 12C20.7703 12.3588 20.5762 12.5944 20.188 13.0657C18.7679 14.7899 15.6357 18 12 18C8.36427 18 5.23206 14.7899 3.81197 13.0657C3.42381 12.5944 3.22973 12.3588 3.22973 12C3.22973 11.6412 3.42381 11.4056 3.81197 10.9343C5.23206 9.21014 8.36427 6 12 6C15.6357 6 18.7679 9.21014 20.188 10.9343Z"
        stroke="currentColor"
      />
    </svg>
  );
};

export const VisibilityOffIcon = ({ width, height, className }: IconProps) => {
  const _w = width || '24';
  const _h = height || '24';
  const _cn = className || '';

  return (
    <svg width={_w} height={_w} className={_cn} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9202 12.7988C15.9725 12.5407 16 12.2736 16 12C16 9.79086 14.2091 8 12 8C11.7264 8 11.4593 8.02746 11.2012 8.07977L12.1239 9.00251C13.6822 9.06583 14.9342 10.3178 14.9975 11.8761L15.9202 12.7988ZM9.39311 10.5143C9.14295 10.9523 9 11.4595 9 12C9 13.6569 10.3431 15 12 15C12.5405 15 13.0477 14.857 13.4857 14.6069L14.212 15.3332C13.5784 15.7545 12.8179 16 12 16C9.79086 16 8 14.2091 8 12C8 11.1821 8.24547 10.4216 8.66676 9.78799L9.39311 10.5143Z"
        fill="#106657"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1545 17.2751L15.4201 16.5406C14.3561 17.1196 13.1994 17.5 12.0007 17.5C10.3289 17.5 8.73889 16.7599 7.36787 15.7735C6.00079 14.79 4.89379 13.5918 4.19865 12.7478C3.7743 12.2326 3.73047 12.1435 3.73047 12C3.73047 11.8565 3.7743 11.7674 4.19865 11.2522C4.86794 10.4396 5.91904 9.29863 7.21645 8.33704L6.50212 7.62271C5.17064 8.63072 4.10457 9.79349 3.42677 10.6164L3.36796 10.6876C3.03744 11.087 2.73047 11.4579 2.73047 12C2.73047 12.5421 3.03744 12.913 3.36796 13.3124L3.42677 13.3836C4.15172 14.2638 5.32087 15.5327 6.78385 16.5853C8.24289 17.635 10.0368 18.5 12.0007 18.5C13.5108 18.5 14.9204 17.9886 16.1545 17.2751ZM9.19066 6.06861C10.0705 5.71828 11.0142 5.5 12.0007 5.5C13.9646 5.5 15.7586 6.365 17.2176 7.41472C18.6806 8.46727 19.8498 9.73623 20.5747 10.6164L20.6335 10.6876C20.9641 11.087 21.271 11.4579 21.271 12C21.271 12.5421 20.9641 12.913 20.6335 13.3124L20.5747 13.3836C20.0943 13.9669 19.4187 14.721 18.5918 15.4697L17.8838 14.7617C18.6794 14.0456 19.3346 13.3164 19.8028 12.7478C20.2272 12.2326 20.271 12.1435 20.271 12C20.271 11.8565 20.2272 11.7674 19.8028 11.2522C19.1077 10.4082 18.0007 9.21001 16.6336 8.22646C15.2626 7.24007 13.6726 6.5 12.0007 6.5C11.3063 6.5 10.626 6.62768 9.9697 6.84765L9.19066 6.06861Z"
        fill="#106657"
      />
      <path d="M5 2L21 18" stroke="currentColor" />
    </svg>
  );
};
